import { Box, Paper, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { FC, ReactNode } from 'react';

const useStyles = makeStyles((theme: any) => ({
  section: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.border.card}`,
    borderRadius: 4,
    boxShadow: 'none',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  title: {
    color: theme.palette.tab.offselected,
    fontWeight: 500,
  },
  action: {
    display: 'flex',
    alignItems: 'center',
    '@media (hover: none) and (pointer: coarse)': {
      '& .MuiIconButton-root': {
        minWidth: theme.spacing(5.5),
        minHeight: theme.spacing(5.5),
      },
    },
  },
}));

type PartySectionProps = {
  title: string;
  action?: ReactNode;
  children: ReactNode;
};

const PartySection: FC<PartySectionProps> = ({ title, action, children }) => {
  const classes = useStyles();

  return (
    <Paper component="section" variant="outlined" aria-label={title} className={classes.section}>
      <Box className={classes.header}>
        <Typography variant="body1" component="h3" className={classes.title}>
          {title}
        </Typography>
        {action && <Box className={classes.action}>{action}</Box>}
      </Box>
      {children}
    </Paper>
  );
};

export default PartySection;
